import { select, DisposalSet, selectAll } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

const gc = new DisposalSet();

const FOCUS_OUT_DELAY = 150;
const STATE_TOGGLE_TIMEOUT = 300;

registerFragment('cbdce-header', (fragmentElement, configuration, meta) => {
    gc.disposeAll();

    const openBtn = document.querySelector<HTMLButtonElement>('.cbdce-mobile-open');
	if (!openBtn) return;

    const mobileNavElement = document.querySelector<HTMLLinkElement>('.cbdce-site-header__top a');

	gc.register(openBtn).addListener('click', () => {
		if (document.body.classList.contains('mobile-nav-open')) {
			document.body.classList.remove('mobile-nav-open');
		} else {
			document.body.classList.add('mobile-nav-open');
		}
	});

    const searchOpenBtn = document.querySelector<HTMLButtonElement>('.cbdce-search-open');
    const searchFlyoutWrap = document.querySelector<HTMLDivElement>('.cbdce-search-flyout-wrap');
    const searchFlyoutInput = document.querySelector<HTMLInputElement>('.cbdce-search-flyout .form-control');

    if (!searchOpenBtn) return;
	gc.register(searchOpenBtn).addListener('click', (e) => {
        e.stopPropagation();

        if (document.body.classList.contains('search-flyout-open')) {
            document.body.classList.remove('search-flyout-open');
            searchOpenBtn.setAttribute('aria-expanded', 'false');
        } else {
            document.body.classList.add('search-flyout-open');
            searchOpenBtn.setAttribute('aria-expanded', 'true');
            searchFlyoutInput?.focus();
            function closeSearchFlyout(e) {
                if (e.type == 'click' && !searchFlyoutWrap?.contains(e.target as Node) || e.type == 'keydown' && e.key === 'Escape') {
                    document.body.classList.remove('search-flyout-open');
                    document.removeEventListener('click', closeSearchFlyout);
                    document.removeEventListener('keydown', closeSearchFlyout);
                    searchOpenBtn?.setAttribute('aria-expanded', 'false');
                };
            }
            document.addEventListener('click', closeSearchFlyout);
            document.addEventListener('keydown', closeSearchFlyout);
        }
	});

    // Main menu
    const isEditMode = document.body.classList.contains('has-edit-mode-menu');

    const navItemEls = selectAll<HTMLDivElement>(fragmentElement, '.cbdce-header-nav-item');
    navItemEls.forEach(navItemEl => {
        if(navItemEl.querySelector('.cbdce-header-nav-item__submenu')) {
            const submenuEl = select<HTMLDivElement>(navItemEl, '.cbdce-header-nav-item__submenu');
            const toggleEl = select<HTMLButtonElement>(navItemEl, '.cbdce-header-nav-item__toggle');
            // const submenuAccordionEls = selectAll<HTMLDivElement>(submenuEl, '.cbdce-accordion');
            let contextPopped = false;
            let innerClicked = false;
            let manualClose = false;
            let toggleClicked = false;

            (gc.register(toggleEl)
                .addListener('click', (e) => {
                    toggleClicked = true;
                    setTimeout(() => { toggleClicked = false; }, STATE_TOGGLE_TIMEOUT);
                    const wasOpen = navItemEl.classList.contains('cbdce-header-nav-item--open');
                    navItemEl.classList.toggle('cbdce-header-nav-item--open');
                    if(toggleEl.getAttribute('aria-expanded') == 'true') {
                        toggleEl.setAttribute('aria-expanded', 'false');
                    } else {
                        toggleEl.setAttribute('aria-expanded', 'true');
                    }
                    if (wasOpen) {
                        manualClose = true;
                        setTimeout(() => { manualClose = false; }, STATE_TOGGLE_TIMEOUT);
                    } else {
                        // console.log('test was not open');
                        // submenuAccordionEls.forEach((accordionEl) => {
                        //     const accordion = accordionRegistry.get(accordionEl);
                        //     if (accordion) accordion.resize();
                        // });
                    }
                })
            );

            if (!isEditMode) { // make open/close strictly controlled by toggle clicking when in edit mode
                (gc.register(submenuEl)
                    .addListener('contextmenu', e => {
                        contextPopped = true;
                        setTimeout(() => {
                            contextPopped = false;
                        }, STATE_TOGGLE_TIMEOUT);
                    })
                    .addListener('focusout', e => {
                        setTimeout(() => {
                            // use timeout here because document.activeElement does not update instantly. Also, focusout triggers
                            // before document.click even when we wrap with rAF. If there is an outside click, we need to wait
                            // until the value of inside clicked is updated
                            if (
                                document.activeElement
                                && !submenuEl.contains(document.activeElement)
                                && !manualClose
                                && !innerClicked
                                && !contextPopped
                            ) {

                                navItemEl.classList.remove('cbdce-header-nav-item--open');
                                toggleEl.setAttribute('aria-expanded', 'false');
                            }
                            // console.log(`[${instance}] focusout:  manualClose: ${manualClose}, innerClicked: ${innerClicked}, contextPopped: ${contextPopped}`, document.activeElement);
                        }, FOCUS_OUT_DELAY)
                    })
                );
                (gc.register(document)
                    .addListener('click', e => {
                        if (toggleClicked) return;
                        // console.log(`[${instance}] document.click: innerClick: ${e.target && submenuEl.contains(e.target as Node)} manualClose: ${manualClose}, innerClicked: ${innerClicked}, contextPopped: ${contextPopped}`, document.activeElement, e.target);
                        if (e.target && submenuEl.contains(e.target as Node)) {
                            innerClicked = true;
                            setTimeout(() => {
                                innerClicked = false;
                            }, STATE_TOGGLE_TIMEOUT);
                        } else {
                            navItemEl.classList.remove('cbdce-header-nav-item--open');
                            toggleEl.setAttribute('aria-expanded', 'false');
                        }
                    })
                );
            }
        };
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => {
        gc.disposeAll();
    });
}
